<template lang="pug">
#SourceUniversity

    .box(v-if="load_data_status_search_by_name_university === 'loading'")
        .box__body.p-4
            Loading(show="true")

    template(v-else)

        .grid.grid-cols-4.gap-8(v-if="search_by_name_university && search_by_name_university.length > 0")
            .box(style="margin-bottom: 0px;" v-for="univ in search_by_name_university")
                .box__header.no-border
                    header.flex.items-center.justify-between
                        .header-meta
                            h2.subheading {{ univ.nama ? univ.nama : '-' }}
                .box__body.p-4
                    // .block.mb-4
                    //     span.block.mb-1 Id
                    //     .block.text-white
                    //         span {{ univ.id ? univ.id : '-' }}
                    .block.mb-4
                        span.block.mb-1 Kode
                        .block.text-white
                            span {{ univ.kode ? univ.kode : '-' }}
                    .block.mb-4
                        span.block.mb-1 Kode Satker
                        .block.text-white
                            span {{ univ.kode_satker ? univ.kode_satker : '-' }}
                    // .block.mb-4
                    //     span.block.mb-1 Name
                    //     .block.text-white
                    //         span {{ univ.nama ? univ.nama : '-' }}
                    .block.mb-4
                        span.block.mb-1 Short Name
                        .block.text-white
                            span {{ univ.nama_singkat ? univ.nama_singkat : '-' }}
                    .block.mb-4
                        span.block.mb-1 SK Pendirian
                        .block.text-white
                            span {{ univ.sk_pendirian ? univ.sk_pendirian : '-' }}
                    .block.mb-4
                        span.block.mb-1 Tanggal SK Pendirian
                        .block.text-white
                            span {{ univ.tgl_sk_pendirian ? univ.tgl_sk_pendirian : '-' }}
                    .block.mb-4
                        span.block.mb-1 SK Operational
                        .block.text-white
                            span {{ univ.sk_operasional ? univ.sk_operasional : '-' }}
                    .block.mb-4
                        span.block.mb-1 Tanggal SK Operational
                        .block.text-white
                            span {{ univ.tgl_sk_operasional ? univ.tgl_sk_operasional : '-' }}
                    .block.mb-4
                        span.block.mb-1 Status
                        .block.text-white
                            span {{ univ.status ? univ.status : '-' }}
                    .block.mb-4
                        span.block.mb-1 Alamat
                        .block.text-white 
                            span {{getAlamat(univ.alamat)}}
                    .block.mb-4
                        span.block.mb-1 Provinsi
                        .block.text-white
                            span {{getObjectName(univ.propinsi)}}
                            
                    .block.mb-4
                        span.block.mb-1 Telepon
                        .block.text-white
                            span {{ univ.telepon ? univ.telepon : '-' }}
                    .block.mb-4
                        span.block.mb-1 Fax
                        .block.text-white
                            span {{ univ.faksimile ? univ.faksimile : '-' }}
                    .block.mb-4
                        span.block.mb-1 Website
                        .block.text-white
                            span(v-if="univ.website")
                                a(:href="checkWeb(univ.website)" target="_blank") {{univ.website}} 
                            span(v-else) - 
                    .block.mb-4
                        span.block.mb-1 Email
                        .block.text-white
                            span {{ univ.email ? univ.email : '-' }}
                    .block.mb-4
                        span.block.mb-1 Status Milik
                        .text-white.grid.grid-cols-2
                            span {{getObjectName(univ.status_milik)}}
                    .block.mb-4
                        span.block.mb-1 Pembina
                        .text-white.grid.grid-cols-2
                            span {{getObjectName(univ.pembina)}}
                    .block.mb-4
                        span.block.mb-1 Bentuk Pendidikan
                        .text-white.grid.grid-cols-2
                            span {{getObjectName(univ.bentuk_pendidikan)}}
                    .block.mb-4
                        span.block.mb-1 Negara
                        .text-white.grid.grid-cols-2
                            span {{getObjectName(univ.negara)}}
                    .block.mb-4
                        span.block.mb-1 Pimpinan
                        .text-white.grid.grid-cols-2
                            span {{getPimpinan(univ.pimpinan)}}
                    .block.mb-4
                        span.block.mb-1 Last Update
                        .block.text-white
                            span {{ univ.last_update ? univ.last_update : '-' }}


        .box(v-else)
            NoDataAvailable
</template>

<script>
import { mapState } from 'vuex';
import { decrypt } from '@/util/crypto';
import NoDataAvailable from '@/components/NoDataAvailable.vue';
import Loading from '@/components/Loading.vue';

export default {
    name: 'SourceUniversity',
    components: {
        NoDataAvailable,
        Loading,
    },
    data(){
        return {
            filterShow: false,
            keyword: '',
            data_result: [],
        }
    },
    computed: {
        ...mapState([
            'load_data_status_search_by_name_university',
            'search_by_name_university',
        ]),
        route_name() {
            return this.$route.name;
        },
        key() {
            return this.$route.params.key;
        },
        isKey() {
            return this.key ? true : false;
        },
    },
    watch: {
        key() {
            this.$store.commit('setSearchByNameUniversity', []);
            this.getData()
        },
        isKey() {},
    },
    methods: {
        checkWeb(web) {
            if (web){
                if (web.substr(0, 3).toLowerCase() != 'http')
                    web = '//'+web;
            }
            return web;
        },
        getPimpinan(data) {
            let result = '-';

            if (!data) return result;
            if (typeof data=='string') return result;
            if (data.length==0) return result;

            let name = data['nama'] ? data['nama'] : '-';
            let start = data['tmt_sk_pengangkatan'] ? (data['tmt_sk_pengangkatan'].trim() ? data['tmt_sk_pengangkatan'].trim() : '') : '';
            let end = data['tst_sk_pengangkatan'] ? (data['tst_sk_pengangkatan'].trim() ? data['tst_sk_pengangkatan'].trim() : '') : '';

            result = name
            if (start || end)
                result += ' ['+start+' - '+end+']';
            
            return result;
        },
        getObjectName(data, first='') {
            let result = '-'

            if (!data) return result;
            if (typeof data=='string') return result;
            if (data.length==0) return result;
            if (!data.nama) return result;
            if (!data.nama.trim()) return result;

            result = first+data.nama.trim();
            return result;
        },
        getAlamat(data, first=', ') {
            let result = '-';

            if (!data) return result;
            if (data.length==0) return result;
            
            const arrList = ['jalan','rt','rw','dusun','kelurahan','kab_kota','kode_pos']
            
            for (let key of arrList) {
                let val = data[key] ? data[key] : null;

                if (!val) continue;

                let valTrim = '';
                if (typeof val=='string')
                    valTrim = val.trim();
                else
                    valTrim = this.getObjectName(val);
                
                if (!valTrim) continue;
                if (valTrim=='-') continue;
                
                if (result==='-') result = '';
                result += (result?first:'');
                result += valTrim;
            }
            return result;
        },
        async getData() {
            if (this.route_name != 'PageUnivName' ) return '';
            if (this.isKey) {
                let decrypt_data = decrypt(this.key);
                decrypt_data = decrypt_data.split('&&');
                var key = decrypt_data[0];

                this.keyword = key;

                await this.$store.dispatch('getSearchByNameUniversity', [key]);
            } else {
                this.$store.commit('setSearchByNameUniversity', []);
            }
        },
        // reset() {

        //     this.$swal.fire({
        //         icon: 'warning',
        //         title: 'Are you sure you want to reset?',
        //         // text: 'Role : ' + name,
        //         confirmButtonText: 'Yes!',
        //         confirmButtonColor: '#DD6B55',
        //         showCancelButton: true,
        //         allowOutsideClick: false,
        //     })
        //     .then((result) => {
        //         // console.log('on result');
        //         if (result.isConfirmed) {
        //             this.gender = '';
        //             this.year_of_birth = '';
        //             this.age_min = '';
        //             this.age_max = '';

        //             this.getData(true);
        //         }
        //     });

        // },
    },
    mounted() {
        this.getData();
    },
}
</script>